import { actions as notifActions } from 'redux-notifications';
import * as i18n from 'i18next';
import { IStore } from 'redux/IStore';
import { IShopOrderResponse, IShopOrder, IShopOrderShipping, ISinergiaShippingRequest } from 'models/orders/order';
import { IShopOrderCardData, IShopOrderCardAction } from 'models/orders/ordercard';
import { ShippingStatus } from 'models';
import countries from './contries';
import { requestHelper } from 'redux/helpers';
import { ICustomer } from 'models/shop/customer';

const { notifSend } = notifActions;

/** Action Types */
export const GET_REQUEST: string = 'shopordercard/GET_REQUEST';
export const GET_SUCCESS: string = 'shopordercard/GET_SUCCESS';
export const GET_FAILURE: string = 'shopordercard/GET_FAILURE';
export const CLEAR_DATA: string = 'shopordercard/CLEAR_DATA';
export const SHIPPING_REQUEST: string = 'shopordercard/SHIPPING_REQUEST';
export const SHIPPING_SUCCESS: string = 'shopordercard/SHIPPING_SUCCESS';
export const SHIPPING_FAILURE: string = 'shopordercard/SHIPPING_FAILURE';

/** Initial State */
const initialState: IShopOrderCardData = {
	shopOrder: null,
	isFetching: false,
};

/** Reducer */
export function shopOrderCardReducer(state = initialState, action: IShopOrderCardAction) {
	switch (action.type) {
		case GET_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				shopOrder: action.payload.shopOrder,
				isFetching: false,
			});

		case GET_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});

		case CLEAR_DATA:
			return Object.assign({}, state, {
				shopOrder: null,
			});

		case SHIPPING_REQUEST:
		case SHIPPING_SUCCESS:
			return Object.assign({}, state, {
				shippingError: undefined,
				isFetching: false,
			});

		case SHIPPING_FAILURE:
			return Object.assign({}, state, {
				shippingError: action.payload.message,
				isFetching: false,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getShopOrder(shopOrderId: string, getCustomerData?: boolean) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopOrderCardRequest());

		//let shopOrder = null;
		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/GetShopOrder/' + shopOrderId,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IShopOrderResponse) => {
						const shopOrder = res.shopOrder;
						shopOrder.order = {
							id: shopOrder.orderId,
							email: res.email,
							shippingAddressLine: res.shippingAddressLine,
							shippingCallingCodeKey: res.shippingCallingCodeKey,
							shippingCity: res.shippingCity,
							shippingCountryKey: res.shippingCountryKey,
							shippingName: res.shippingName,
							shippingNote: res.shippingNote,
							shippingPhoneNumber: res.shippingPhoneNumber,
							shippingState: res.shippingState,
							shippingZIPCode: res.shippingZIPCode,

							billingAddressLine: res.billingAddressLine,
							billingCity: res.billingCity,
							billingCountryKey: res.billingCountryKey,
							billingName: res.billingName,
							billingState: res.billingState,
							billingZIPCode: res.billingZIPCode,
							paymentStatus: res.paymentStatus,
							message: res.message,
						};
						if (getCustomerData && shopOrder?.customerId) {
							return requestHelper<ICustomer>(
								fetch(
									getState().fetchDefault.baseAPI + `api/Shop/Customers/${shopOrder.customerId}`,
									Object.assign({}, getState().fetchDefault.requestInit),
								),
							)
								.then((customerData: ICustomer) => {
									if (customerData?.email === 'walk-in@glossiq.com') {
										customerData.email === undefined;
										customerData.name = i18n.t('Customer_Walk-in');
									}
									Object.assign(shopOrder, { customerData });
									return dispatch(getShopOrderCardSuccess(shopOrder));
								})
								.catch((res2) => {
									const message: any = { status: res2.status, statusText: res2.statusText };
									console.error(message);
									// dispatch(shopOrderCardFailure(message));
								});
						} else {
							return dispatch(getShopOrderCardSuccess(shopOrder));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							return dispatch(shopOrderCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							return dispatch(shopOrderCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(shopOrderCardFailure(err));
			});
	};
}

/** Action Creator */
export function shipOrder(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopOrderCardRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/order/' + id + '/SetShippingStatus/' + ShippingStatus.Shipped,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
			}),
		)
			.then((res) => {
				if (res.ok) {
					const order = getState().shopOrderCard.shopOrder;
					order.shippings[0].status = ShippingStatus.Shipped;
					dispatch(getShopOrderCardSuccess(order));
					dispatch(
						notifSend({ message: i18n.t('Notification_Success_Order_Sent'), kind: 'success', dismissAfter: 3000 }),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(shopOrderCardFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(shopOrderCardFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(shopOrderCardFailure(err));
			});
	};
}

function get2CharCountryCode(
	countryKey: number,
	getState: () => IStore,
	setError: (key: any) => void,
): Promise<string> {
	const apiCountries = getState().domainValues.countries;
	let getCountries = Promise.resolve(apiCountries);
	if (!apiCountries) {
		getCountries = fetch(
			getState().fetchDefault.baseAPI + 'api/Country',
			Object.assign({}, getState().fetchDefault.requestInit),
		).then((res) => {
			if (res.ok) {
				return res.json();
			}
		});
	}
	return getCountries
		.then((dvs) => {
			const dvalue = dvs.find((dv) => String(dv.key) === String(countryKey));
			if (!dvalue) {
				throw new Error('Cannot find API country ' + countryKey);
			}
			const lcname = dvalue.value.toLowerCase();
			const iso = countries.find((c) => c.name.toLowerCase() === lcname);
			if (!iso) {
				throw new Error('Cannot find ISO country ' + lcname + ' (' + countryKey + ')');
			}
			return iso.alpha2;
		})
		.catch((e) => {
			setError(countryKey);
			console.error(e);
			return '';
		});
}

type DeepRequired<T> = {
	[P in keyof T]: Required<T[P]>;
};

/** Action Creator */
export function createOrderShipping(orderId: string, shippingId: string, data: DeepRequired<IShopOrderShipping>) {
	return (dispatch, getState: () => IStore) => {
		dispatch(shopOrderCardRequest());

		if (shippingId === undefined) {
			return dispatch(shopOrderShippingFailure('shippingId missing'));
		}
		if (orderId === undefined) {
			return dispatch(shopOrderShippingFailure('orderId missing'));
		}
		let isCountryError = false;
		const setCountryError = (key: any) => {
			isCountryError = true;
			dispatch(shopOrderShippingFailure('Cannot get country code for ' + key));
		};
		if (isCountryError) {
			return;
		}

		return Promise.all([
			get2CharCountryCode(data.shipping.goods_origin, getState, setCountryError),
			get2CharCountryCode(data.order.shippingCountryKey, getState, setCountryError),
			get2CharCountryCode(data.sender.shippingFromCountryKey, getState, setCountryError),
		])
			.then((countries) => ({
				goods_origin: countries[0].toUpperCase(),
				shipping_country_code: countries[1].toUpperCase(),
				sender_country_code: countries[2].toUpperCase(),
			}))
			.then((countries) => {
				const sinergiaShippingRequest: ISinergiaShippingRequest = {
					goods_origin: countries.goods_origin,
					goods_type: data.shipping.goods_type || '',
					packages: data.shipping.packages || [],
					trade_documents: data.shipping.trade_documents || [],

					courier_code: 0,
					service_code: 0,
					currency: 'EUR',

					order_number: orderId,
					total_packages: data.shipping.packages ? data.shipping.packages.length : 0,
					weight: data.shipping.packages ? data.shipping.packages.reduce((acc, val) => acc + val.weight, 0) : 0,
					volume: data.shipping.packages ? data.shipping.packages.reduce((acc, val) => acc + val.volume, 0) : 0,

					shipping_name: data.order.shippingName || '',
					shipping_address: data.order.shippingAddressLine || '',
					shipping_city: data.order.shippingCity || '',
					shipping_contact: data.order.shippingName || '',
					shipping_country_code: countries.shipping_country_code,
					shipping_email: data.order.email || '',
					shipping_phone: data.order.shippingPhoneNumber || '',
					shipping_postal_code: data.order.shippingZIPCode || '',
					shipping_note: data.order.shippingNote || '',
					shipping_province: data.order.shippingState || '',

					sender_name: data.sender.shippingName || '',
					sender_address: data.sender.shippingAddress || '',
					sender_city: data.sender.shippingCity || '',
					sender_contact: data.sender.shippingName || '',
					sender_country_code: countries.sender_country_code,
					sender_email: data.sender.shippingEmail || '',
					sender_phone: data.sender.shippingPhone || '',
					sender_postal_code: data.sender.shippingPostalCode || '',
					sender_province: data.sender.shippingProvince || '',
				};

				return fetch(
					getState().fetchDefault.baseAPI + 'api/order/' + shippingId + '/Ship/',
					Object.assign({}, getState().fetchDefault.requestInit, {
						method: 'PUT',
						body: JSON.stringify(sinergiaShippingRequest),
					}),
				)
					.then((res) => {
						if (res.ok) {
							const order = getState().shopOrderCard.shopOrder;
							order.shippings[0].status = ShippingStatus.Shipped;
							dispatch(getShopOrderShippingSuccess(order));
							dispatch(
								notifSend({ message: i18n.t('Notification_Success_Order_Sent'), kind: 'success', dismissAfter: 3000 }),
							);
							dispatch(getShopOrder(orderId));
						} else {
							const statusText: string = res.statusText;
							return res
								.json()
								.then(() => {
									dispatch(shopOrderShippingFailure(statusText));
								})
								.catch(() => {
									dispatch(shopOrderShippingFailure(statusText));
								});
						}
					})
					.catch((err) => {
						dispatch(shopOrderShippingFailure(err));
					});
			});
	};
}

/** Action Creator */
export function shopOrderCardRequest(): IShopOrderCardAction {
	return {
		type: GET_REQUEST,
	};
}

/** Action Creator */
export function getShopOrderCardSuccess(shopOrder: IShopOrder): IShopOrderCardAction {
	return {
		type: GET_SUCCESS,
		payload: {
			shopOrder,
		},
	};
}

/** Action Creator */
export function shopOrderCardFailure(message: any): IShopOrderCardAction {
	return {
		type: GET_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function clearData(): IShopOrderCardAction {
	return {
		type: CLEAR_DATA,
	};
}

/** Action Creator */
export function shopOrderShippingRequest(): IShopOrderCardAction {
	return {
		type: SHIPPING_REQUEST,
	};
}
/** Action Creator */
export function getShopOrderShippingSuccess(shopOrder: IShopOrder): IShopOrderCardAction {
	return {
		type: SHIPPING_SUCCESS,
		payload: {
			shopOrder,
		},
	};
}

/** Action Creator */
export function shopOrderShippingFailure(message: string): IShopOrderCardAction {
	return {
		type: SHIPPING_FAILURE,
		payload: {
			message,
		},
	};
}
